import { MatDialogConfig } from '@angular/material/dialog';

/**
 * App-wide MAT_DIALOG_DEFAULT_OPTIONS. This token REPLACES Material's built-in MatDialogConfig
 * rather than merging into it, so anything we leave out is lost on every dialog. Kept here:
 * - closeOnNavigation false — a Back press is a navigation, and OverlayBackStackService owns
 *   what Back closes (one layer per press);
 * - role 'dialog' + ariaModal — what Material sets by default; without them screen readers
 *   do not announce dialogs and `getByRole('dialog')` finds nothing (OE-212).
 * Material's focus defaults (autoFocus 'first-tabbable', restoreFocus) are deliberately NOT
 * restored here: dialogs have run without them since the Back-stack change, and autofocusing
 * the first field would pop the phone keyboard on open.
 */
export const APP_DIALOG_DEFAULTS: MatDialogConfig = {
    closeOnNavigation: false,
    role: 'dialog',
    ariaModal: true,
};
